import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=6cf7c3a5&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=ts&"
export * from "./editForm.vue?vue&type=script&lang=ts&"
import style0 from "./editForm.vue?vue&type=style&index=0&id=6cf7c3a5&prod&lang=scss&"
import style1 from "./editForm.vue?vue&type=style&index=1&id=6cf7c3a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7c3a5",
  null
  
)

export default component.exports